import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SilentAuthService } from '../services/silent-auth.service';
import { UserService } from '../services/user.service';

type ConfirmationStatus = 'loading' | 'success' | 'error';

@Component({
  selector: 'app-email-confirmation',
  templateUrl: './email-confirmation.component.html',
  styleUrl: './email-confirmation.component.sass',
  standalone: false
})
export class EmailConfirmationComponent implements OnInit, OnDestroy {
  status: ConfirmationStatus = 'loading';
  private redirectTimeoutId: ReturnType<typeof setTimeout> | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private silentAuthService: SilentAuthService
  ) {}

  ngOnInit(): void {
    const activationKey = this.route.snapshot.paramMap.get('activationKey');
    if (!activationKey) {
      this.status = 'error';
      return;
    }
    this.activateEmail(activationKey);
  }

  ngOnDestroy(): void {
    if (this.redirectTimeoutId !== null) {
      clearTimeout(this.redirectTimeoutId);
    }
  }

  private activateEmail(activationKey: string): void {
    this.userService.activateEmail(activationKey).subscribe({
      next: () => {
        this.silentAuthService.performSilentAuth()
          .then(() => {
            this.status = 'success';
            this.redirectTimeoutId = setTimeout(() => {
              this.router.navigate(['/condominiums']);
            }, 3000);
          })
          .catch(() => {
            this.status = 'error';
          });
      },
      error: () => {
        this.status = 'error';
      }
    });
  }
}
